import {
  SET_QUOTATION_ORDER_DATA,
  SET_QUOTATION_ORDER_DATA_STATUS,
  SELECT_QUOTATION,
  GET_QUOTATION_DETAIL_DATA,
  SET_QUOTATION_DETAIL_STATUS,
} from '../helpers/types';

const INITIAL_STATE = {
  quotationDataArr: [],
  isLoading: false,
  quotationData: {},
  top: 20,
  listCount: null,
  selQuotationDetailData: null,
  isQuotationDetailLoading: false,
  failText: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_QUOTATION_ORDER_DATA:
      return {
        ...state,
        quotationDataArr: action.payload.data,
        isLoading: false,
        listCount: action.payload.listCount,
      };
    case SET_QUOTATION_ORDER_DATA_STATUS:
      return {
        ...state,
        ...action.payload,
      };

    case GET_QUOTATION_DETAIL_DATA:
      return {
        ...state,
        selQuotationDetailData: action.payload.selQuotationDetailData,
        isQuotationDetailLoading: false,
      };
    case SET_QUOTATION_DETAIL_STATUS:
      return {
        ...state,
        isQuotationDetailLoading: action.payload.isQuotationDetailLoading,
      };
    case SELECT_QUOTATION:
      return { ...state, quotationData: action.payload };
    default:
      return state;
  }
};
